<template>
  <div>
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addCustom" v-if="permissionCodes.indexOf('004029001') !== -1"/>
      </div>

    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :deleteTipInfo="'是否确认删除该车位区域'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" @deleteLine="deleteLine" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :selection="false" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-lot-area",
  data() {
    return {
      permissionCodes: "",
      config: {
        breadcrumb: [
          {
            value: "智慧停车",
            name: "parking-device-management"
          },
          {
            value: "车位区域"
          }
        ]
      },
      addCustom: "parking-lot-area-add",

      tableHead: [
        {
          prop: "parkingLotAreaName",
          label: "车位区域"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      operationArr: ["modify", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios
        .post(api.getParkingLotAreaPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch(errorHandler("获取车位区域数据失败"));
    },
    search(v) {
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/parking_lot_area_modify/${code}`
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteParkingLotArea, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPage();
          }
        })
        .catch(errorHandler("删除配置失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingLotArea/ParkingLotArea.vue